
export function allHaveOrNot(keys = [], target) {
    const i_v = ['', null, undefined]
    if (!target || !keys || !keys.length) {
        return true
    }
    const all_have_not = keys.every(key => i_v.includes(target[key]))
    const all_have = keys.every(key => !i_v.includes(target[key]))
    return all_have_not || all_have
}